class MaterialExplorer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced) return;
    this.tabs = [...this.querySelectorAll('[data-material-tab]')];
    this.panels = [...this.querySelectorAll('[data-material-panel]')];
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
    this.dataset.enhanced = 'true';
    const list = this.querySelector('[data-material-tabs]');
    list.hidden = false;
    list.setAttribute('role', 'tablist');
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      this.panels[index].setAttribute('role', 'tabpanel');
      this.panels[index].setAttribute('aria-labelledby', tab.id);
      this.panels[index].tabIndex = 0;
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => {
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
        else return;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      });
    });
    this.select(0);
  }
  select(index) {
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      this.panels[i].hidden = i !== index;
    });
  }
}
class ProductViewSwitcher extends HTMLElement {
  connectedCallback() {
    if (this.dataset.view) return;
    this.dataset.view = 'room';
    this.querySelector('[data-view-options]').hidden = false;
    const buttons = [...this.querySelectorAll('[data-product-view]')];
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.productView === 'room')));
    buttons.forEach(button => button.addEventListener('click', () => {
      this.dataset.view = button.dataset.productView;
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
  }
}
if (!customElements.get('material-explorer')) customElements.define('material-explorer', MaterialExplorer);
if (!customElements.get('product-view-switcher')) customElements.define('product-view-switcher', ProductViewSwitcher);
document.addEventListener('input', (event) => {
  const calculator = event.target.closest('wall-area-calculator');
  if (!calculator) return;
  const planner = calculator.closest('.studio-planner');
  const width = Number(calculator.querySelector('[name="width"]').value);
  const height = Number(calculator.querySelector('[name="height"]').value);
  const widthLabel = planner.querySelector('[data-wall-width]');
  const heightLabel = planner.querySelector('[data-wall-height]');
  if (widthLabel) widthLabel.textContent = width > 0 ? `${width} m` : '— m';
  if (heightLabel) heightLabel.textContent = height > 0 ? `${height} m` : '— m';
  const drawing = planner.querySelector('.signature-wall');
  if (drawing && width > 0 && height > 0) {
    const maxWidth = matchMedia('(max-width: 749px)').matches ? 170 : 230;
    const maxHeight = maxWidth * .75;
    const scale = Math.min(maxWidth / width, maxHeight / height);
    drawing.style.width = `${Math.max(2, width * scale)}px`;
    drawing.style.height = `${Math.max(2, height * scale)}px`;
  }
  calculator.querySelector('[role="status"]').textContent = calculator.dataset.resetMessage;
  calculator.querySelector('[data-quote]').href = 'https://wa.me/972509445045';
});
